import { createContext } from 'react';
import { RequestPublicForm } from '../types';

export type SetValueFn = <T extends keyof RequestPublicForm, K extends RequestPublicForm[T]>(key: T, value: K) => void;

export type ValidateStepFn = (callback: () => boolean) => void;

export type FormWizard = {
    data: RequestPublicForm;
    setValue: SetValueFn;
    validateStep: ValidateStepFn;
};

const FormWizardContext = createContext<FormWizard>({} as FormWizard);

export default FormWizardContext;